















import ApiConfiguration from '@/classes/ApiConfiguration';
import { UserNotificationModel } from '@/services/GeneratedApi';
import Toast from '@/classes/SnotifyConfiguration';

export default {
  name: 'DefaultNotificationAction',
  data() {
    return {
      showModal: false
    };
  },
  props: {
    linkData: {
      type: Object as () => UserNotificationModel
    },
    actionIsDelete: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    async deleteNotification(this: any) {
      this.showModal = true;
      try {
        await ApiConfiguration.api().userNotification.userNotificationDeleteUpdate(this.linkData.id);
        Toast.showSuccess('Notification deleted successfully.');
      } catch (error) {
        this.$log(error);
      } finally {
        this.showModal = false;
        this.$emit('link-action:completed');
      }
    }
  },

  async mounted(this: any) {
    await this.deleteNotification();
  }
};
